<template>
  <div>
   <!-- <div class="footer-nav">
      <div class="footer-top main-width">
        <div class="footer-logo">
          <img src="@/assets/foot_logo.svg" alt="" />
          <ul>
            <li>首页</li>
            <li>资讯</li>
            <li>培训</li>
            <li>首页</li>
            <li>资讯</li>
            <li>培训</li>
            <li>首页</li>
            <li>资讯</li>
          </ul>
        </div>
        <div class="footer-icon">
          <ul>
            <li>
              <img src="@/assets/foot_icon_1.svg" alt="" />
              <p>微信公众号</p>
            </li>
            <li>
              <img src="@/assets/foot_icon_2.svg" alt="" />
              <p>微信小程序</p>
            </li>
            <li>
              <img src="@/assets/foot_icon_3.svg" alt="" />
              <p>APP下载</p>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
	
	
    <div class="footer-address">
      <div class="main-width">
        <div class="foot_left">
          <p><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #ccc;">陇ICP备14001863号-1</a>　&nbsp;&nbsp;<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010202000950" target="_blank" style="color: #ccc;">甘公网安备 62010202000950号</a></p>
          <p>
            地址：甘肃省兰州市城关区雁北路400　&nbsp;&nbsp;联系电话：0931-8260318　13919102878
          </p>
          <p>Copyright备&nbsp;&nbsp;2022甘备&nbsp;&nbsp;兰州文理学院继续教育学习平台所有</p>
        </div>

        <div class="foot_right">
          <a @click="openpop()"><img src="../assets/foot_icon_2.svg"/></a>
          <!-- <a href="#"><img src="../assets/foot_icon_3.svg"/></a> -->
        </div>

        <div class="xcxm" v-if="poptype" @click="closepop()"><img src="../assets/img/index/xcx.jpg" /><span>兰州文理学院继续教育平台小程序</span></div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "footerNav",
  data() {
    return {
      poptype:false,
    };
  },
  methods:{
    openpop(){
      this.poptype = true
    },
    closepop(){
      this.poptype = false
    }
  },
};
</script>
<style lang="less" scoped>
.footer-nav {
  background: #2e2e2e;
  height: 208px;

  .footer-top {
    display: flex;
    justify-content: space-between;
    .footer-icon {
      display: flex;
      ul {
        li {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-right: 50px;
        }
      }
    }
    img {
      margin: 42px 0 28px 0;
    }
    ul {
      display: flex;
      li {
        font-size: 16px;
        color: #ccc;
        margin-right: 40px;
      }
    }
  }
}
.footer-address {
  height: 158px;
  background: #212121;
  .foot_left{
    width: 700px;
    p{
      font-size: 14px;
      color: #ccc;
      text-align: left;
      line-height: 30px;
    }
    p:first-child{
      padding-top: 34px;
    }
  }
  .foot_right{
    width: auto;
    a{
      width: auto;
      display: inline-block;
      height: auto;
      margin: 45px 0 0 30px;
      cursor: pointer;
      img{
        width: 65px;
        height: auto;
      }
    }
  }

}

.main-width {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.xcxm{
  position: fixed;
  left: 0;
  right: 0;
  top:0;
  bottom:0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img{
    position: absolute;
    z-index: 2;
    box-shadow: 0 0 15px rgba(0,0,0,.2),0 0 25px rgba(0,0,0,.2),0 0 35px rgba(0,0,0,.2);
    border-radius: 10px;
    padding:20px;
    background: #fff;
    width: 240px;
    margin-top: -50px;

  }
  span{
    position: absolute;
    z-index: 2;
    margin-top: 300px;
    font-size: 18px;
    background: rgba(0,0,0,.6);
    color: #fff;
    padding:10px 25px;
    border-radius: 100px;
  }
  &::before{
    position: absolute;
    z-index: 1;
    content: "";
    left: 0;
    right: 0;
    top:0;
    bottom:0;
    background: rgba(0,0,0,.4);
  }
  &::after{
    content: "×";
    position: absolute;
    right: 20px;
    top:20px;
    z-index: 9;
    width: 40px;
    height: 40px;
    background: rgba(255,255,255,.3);
    color: #fff;
    font-size: 28px;
    border-radius: 100px;
    text-align: center;
    line-height: 36px;
  }
}
</style>
